import React, { ElementType, ReactElement } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

type option = {
  key: string;
  label: string;
  callback: Function;
  startIcon?: ReactElement;
};

export interface IProps {
  label: string;
  options: option[];
  startIcon?: ReactElement;
  endIcon?: ReactElement;
  component?: ElementType<any>;
  variant?: "text" | "contained" | "outlined";
}

const DropdownButton = ({
  label,
  startIcon,
  endIcon,
  options,
  component,
  variant = "contained",
}: IProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box component={component}>
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant={variant}
        color="primary"
        onClick={handleClick}
        startIcon={startIcon}
        endIcon={endIcon}
      >
        {label}
      </Button>
      {/* @ts-ignore */}

      <Menu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        elevation={0}
        //TODO: commented for mui v5
        // getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          "& .MuiPaper-root": {
            border: "1px solid #d3d4d5",
            marginTop: "5px",
          },
          "& .MuiListItemText-root": {
            my: "4px",
          },
        }}
      >
        {options.map((option) => (
          //@ts-ignore
          <MenuItem
            key={option.key}
            onClick={() => {
              option.callback();
              handleClose();
            }}
            sx={{
              "& .MuiListItemIcon-root": {
                minWidth: "auto",
                marginRight: "10px",
              },
            }}
          >
            {option.startIcon && (
              //@ts-ignore
              <ListItemIcon>{option.startIcon}</ListItemIcon>
            )}

            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default DropdownButton;
